module.exports = __webpack_public_path__ + "img/aej1n-66wvl.021.b5fe7cbe.png";